import { ArrowBack } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { Col, Row, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Button } from "../../common/Button";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FullPageSpinner } from "../../common/Spinner/FullPageSpinner";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { editHCNAuthority, getHCNAuthorityById } from "../../api/HCN";
import { failed, success } from "../../common/Toastify";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import TextArea from "../../common/textfield/TextArea";

const HCNEdit = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const [HCNAuthData, setHCNAuthData] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const params = new URLSearchParams(location.search);
  const hcnId = params.get("hcnId");
  const orgId = params.get("orgId");
  const [regionOptions, setRegionOptions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const onSuccessOrg = (data) => {
      setOrganizations(data?.map((org) => (org = { ...org, value: org.id })));
    };
  useOrgQuery({ onSuccess: onSuccessOrg });

  // Validation schema for formik
  const validationSchema = Yup.object().shape({
    display: Yup.string()
      .max(64, "Maximum 64 characters allowed")
      .required("Display Name is required"),
    description: Yup.string()
      .max(128, "Maximum 128 characters allowed")
      .required("Description is required"),
    authority: Yup.string()
      .max(128, "Maximum 128 characters allowed")
      .required("Authority is required"),
    orgId: Yup.string()
    .required("Required organization")
    .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
  });

  useEffect(() => {
    fetchHCNAuthData();
  }, []);

  const fetchHCNAuthData = () => {
    if (hcnId) {
      setIsLoading(true);
      getHCNAuthorityById(orgId, hcnId)
        .then((res) => {
          if (res?.status === true) {
            setHCNAuthData(res?.data);
          }
        })
        .finally(() => setIsLoading(false));
    }
  };

  return (
    <>
      {isLoading && <FullPageSpinner />}

      <section className="common-listing">
        <div className="heading-wrap mb-3">
          <Tooltip title="Go back">
            <div
              style={{ marginRight: "1rem", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            >
              <ArrowBack />
            </div>
          </Tooltip>
        </div>

        <div className="custom-card p-4">
          <Formik
            enableReinitialize={true}
            initialValues={{
              display: HCNAuthData?.display || "",
              description: HCNAuthData?.description || "",
              authority: HCNAuthData?.authority || "",
              orgId: HCNAuthData?.orgId || "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              setIsLoading(true);

              let payload = {
                active: true,
                authority: values?.authority,
                description: values?.description,
                display: values?.display,
              };

              editHCNAuthority(values?.orgId, hcnId, payload)
                .then((res) => {
                  if (res?.status === true) {
                    success(res?.message);
                    navigate(-1);
                  }
                })
                .catch((res) => {
                  failed(res?.message);
                })
                .finally(() => setIsLoading(false));
            }}
          >
            {(formik) => {

              return (
                <form
                  className="common-form border-fields"
                  onSubmit={formik.handleSubmit}
                >
                  {/* SAML Assertion */}
                  <Row>
                    <Col>
                    {organizations.length > 1 && (
                      <SelectFiled
                        keyField={"orgId"}
                        label={"Select Organization"}
                        formik={formik}
                        options={organizations}
                        readOnly = {true}
                      />
                      )}
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <TextInput
                          type={"text"}
                          keyField={"display"}
                          label={"Display"}
                          formik={formik}
                          placeholder={"Display Name"}
                          required={true}
                          tooltip="The display name displays in the front end when choosing a patient identifier." 
                        />

                        {formik.touched.display && formik.errors.display && (
                          <div className="invalid-feedback">
                            {formik.errors.display}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3">
                        <TextInput
                          type={"text"}
                          keyField={"authority"}
                          label={"Authority"}
                          formik={formik}
                          placeholder={"Authority"}
                          required={true}
                          tooltip="The assigning authority associated with the patient identifier."
                        />
                        {formik.touched.authority &&
                          formik.errors.authority && (
                            <div className="invalid-feedback">
                              {formik.errors.authority}
                            </div>
                          )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group className="mb-3">
                        <TextArea
                          type={"text"}
                          keyField={"description"}
                          label={"Description"}
                          formik={formik}
                          placeholder={"Description"}
                          required={true}
                        />
                        {formik.touched.description &&
                          formik.errors.description && (
                            <div className="invalid-feedback">
                              {formik.errors.description}
                            </div>
                          )}
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Submit Buttons */}
                  <div
                    className="btn-wrap"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "2rem",
                      gap: "1rem",
                    }}
                  >
                    <Button
                      variant="secondary"
                      title="Cancel"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </Button>
                    <Button type="submit">Update</Button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
      </section>
    </>
  );
};

export default HCNEdit;
